module.exports = __webpack_public_path__ + "img/jacket-left-sub-raglan-classic.91adc2da.png";